<div class="rm-header space-between">
  <span>Permissions Debug Console</span>
  <mat-icon mat-dialog-close>close</mat-icon>
</div>
<mat-dialog-content class="full-container">
    <div id="employee">
        <div class="header space-between">
            <h2>Employee Permissions</h2>
            <mat-form-field style="width: 400px">
                <mat-label>Employee Permissions Search</mat-label>
                <input matInput type="text" [(ngModel)]="employeeSearchFilter" (ngModelChange)="filterEmployeePermissions()" />
            </mat-form-field>
        </div>

        <div class="permissions-container">
            <mat-chip-list aria-label="Employee Permissions">
                <mat-chip *ngFor="let chip of filteredEmployeePermissiosn">
                    {{chip}} <mat-icon (click)="removeEmployeePermission(chip)">close</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>

        <div class="add-permissions">
            <form [formGroup]="fgEmployeePermissions" class="space-between" (ngSubmit)="submitEmployee()">
                <mat-form-field style="width: 400px">
                    <mat-label>Add Permission</mat-label>
                    <input matInput formControlName="permission" />
                </mat-form-field>
                <button mat-raised-button color="primary">Add Permission</button>
            </form>
        </div>
    </div>

    <div id="dealteam mt-4" *ngIf="filteredDealTeamPermissions.length > 0">
        <div class="header space-between">
            <h2>Deal Team Permissions</h2>
            <mat-form-field style="width: 400px">
                <mat-label>Deal Team Permissions Search</mat-label>
                <input matInput type="text" [(ngModel)]="dealTeamSearchFilter" (ngModelChange)="filterDealTeamPermissions()" />
            </mat-form-field>
        </div>

        <div class="permissions-container">
            <mat-chip-list aria-label="Deal Team Permissions">
                <mat-chip *ngFor="let chip of filteredDealTeamPermissions">
                    {{chip}} <mat-icon (click)="removeDealTeamPermission(chip)">close</mat-icon>
                </mat-chip>
            </mat-chip-list>
        </div>

        <div class="add-permissions">
            <form [formGroup]="fgDTPermissions" class="space-between" (ngSubmit)="submitDealTeam()">
                <mat-form-field style="width: 400px">
                    <mat-label>Add Deal Team Permission</mat-label>
                    <input matInput formControlName="permission" />
                </mat-form-field>
                <button mat-raised-button color="primary">Add Deal Team Permission</button>
            </form>
        </div>
    </div>
</mat-dialog-content>